var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PrimerTextAreaElement_characterCounter;
import { controller, target } from '@github/catalyst';
import { CharacterCounter } from './character_counter';
let PrimerTextAreaElement = class PrimerTextAreaElement extends HTMLElement {
    constructor() {
        super(...arguments);
        _PrimerTextAreaElement_characterCounter.set(this, null);
    }
    connectedCallback() {
        if (this.characterLimitElement) {
            __classPrivateFieldSet(this, _PrimerTextAreaElement_characterCounter, new CharacterCounter(this.inputElement, this.characterLimitElement, this.characterLimitSrElement), "f");
            __classPrivateFieldGet(this, _PrimerTextAreaElement_characterCounter, "f").initialize();
        }
    }
    disconnectedCallback() {
        __classPrivateFieldGet(this, _PrimerTextAreaElement_characterCounter, "f")?.cleanup();
    }
};
_PrimerTextAreaElement_characterCounter = new WeakMap();
__decorate([
    target
], PrimerTextAreaElement.prototype, "inputElement", void 0);
__decorate([
    target
], PrimerTextAreaElement.prototype, "characterLimitElement", void 0);
__decorate([
    target
], PrimerTextAreaElement.prototype, "characterLimitSrElement", void 0);
PrimerTextAreaElement = __decorate([
    controller
], PrimerTextAreaElement);
export { PrimerTextAreaElement };
if (!window.customElements.get('primer-text-area')) {
    Object.assign(window, { PrimerTextAreaElement });
    window.customElements.define('primer-text-area', PrimerTextAreaElement);
}
